export const GET_AGENTS_QUERY_KEY = 'get_agents';

const AGENTS_STALE_TIME = 30000; // 30 seconds
const AGENTS_GC_TIME = 5 * 60 * 1000; // 5 minutes

export const AGENTS_QUERY_OPTIONS = {
  staleTime: AGENTS_STALE_TIME,
  gcTime: AGENTS_GC_TIME,
};

export const AgentName = {
  TIA: 'Tia',
  SALMA: 'Salma',
  HARRIS: 'Harris',
  OLLIE: 'Ollie',
  KYLE: 'Kyle',
  CONNIE: 'Connie',
} as const;
export type AgentName = (typeof AgentName)[keyof typeof AgentName];
